export enum Measures {
    OPEN_CHANNEL_LOADING_TIME = 'open_channel_loading_time',
    OPEN_CHANNEL_REQUESTS_TIME = 'open_channel_requests_loading_time',
    OPEN_THREAD_LOADING_TIME = 'open_thread_loading_time',
    OPEN_THREAD_REQUESTS_TIME = 'open_thread_requests_time',
    SEND_MESSAGE_LOADING_TIME = 'send_message_loading_time',
    SEND_MESSAGE_REQUESTS_TIME = 'send_message_requests_time',
    OPEN_APP_LOADING_TIME = 'open_app_loading_time',
}
